var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgLinkArrow = function SvgLinkArrow(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.613 1.42417V0.0224609H11.9194V1.42417H13.613ZM15.3065 5.62075V4.21904H17V2.82588H15.3065V1.42417H13.613V2.82588H0V4.21904H13.613V5.62075H15.3065ZM13.613 7.02246V5.62075H11.9194V7.02246H13.613Z",
    fill: "#2BEE4B"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLinkArrow);
var Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTcgOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzLjYxMyAxLjQyNDE3VjAuMDIyNDYwOUgxMS45MTk0VjEuNDI0MTdIMTMuNjEzWk0xNS4zMDY1IDUuNjIwNzVWNC4yMTkwNEgxN1YyLjgyNTg4SDE1LjMwNjVWMS40MjQxN0gxMy42MTNWMi44MjU4OEgwVjQuMjE5MDRIMTMuNjEzVjUuNjIwNzVIMTUuMzA2NVpNMTMuNjEzIDcuMDIyNDZWNS42MjA3NUgxMS45MTk0VjcuMDIyNDZIMTMuNjEzWiIgZmlsbD0iIzJCRUU0QiIvPgo8L3N2Zz4K";